import InfoBlockProperty from "./InfoBlockProperty";

import "./InfoBlockProperty.scss";

export * from "./InfoBlockProperty.types";

export { InfoBlockProperty };
